import {useI18n} from '@logistics-frontend/core/i18n'

export const useSegments = () => {
  const i18n = useI18n()

  return {
    [i18n('bdui.segment.options.auto_products')]: 'auto_products',
    [i18n('bdui.segment.options.ready_meals_and_cooking')]: 'ready_meals_and_cooking',
    [i18n('bdui.segment.options.children_goods')]: 'children_goods',
    [i18n('bdui.segment.options.documents')]: 'documents',
    [i18n('bdui.segment.options.cosmetics_and_perfumes')]: 'cosmetics_and_perfumes',
    [i18n('bdui.segment.options.furniture')]: 'furniture',
    [i18n('bdui.segment.options.medical_products')]: 'medical_products',
    [i18n('bdui.segment.options.clothing_and_accessories')]: 'clothing_and_accessories',
    [i18n('bdui.segment.options.sporting_products')]: 'sporting_products',
    [i18n('bdui.segment.options.construction_products')]: 'construction_products',
    [i18n('bdui.segment.options.household_goods')]: 'household_goods',
    [i18n('bdui.segment.options.leisure_and_hobby_products')]: 'leisure_and_hobby_products',
    [i18n('bdui.segment.options.pet_supplies')]: 'pet_supplies',
    [i18n('bdui.segment.options.goods_for_holidays')]: 'goods_for_holidays',
    [i18n('bdui.segment.options.everyday_products')]: 'everyday_products',
    [i18n('bdui.segment.options.flowers')]: 'flowers',
    [i18n('bdui.segment.options.electronics_and_household_appliances')]: 'electronics_and_household_appliances',
    [i18n('bdui.segment.options.other')]: 'other',
  } as const
}
